import { trackEvent } from 'dibs-tracking';

export function orderFeedbackEvent({ action, label }) {
    trackEvent({
        category: 'seller reviews',
        action,
        label,
        isInteractiveEvent: true,
    });
}
